module.exports = __webpack_public_path__ + "images/carton-group.png";